import { css } from "styled-components/macro"

export const center = css`
	display: flex;
	justify-content: center;
	align-items: center;
`

export const resetButtonStyles = css`
	padding: 0;
	background: none;
	border: none;
	box-shadow: none;
	display: block;
	border-radius: 0;
	outline: none;
	cursor: pointer;
`
